let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5UA41")).then(() => parcelRequire('aozTf'));